// extracted by mini-css-extract-plugin
module.exports = {"alert":"_6aa34d5"};